<template lang="pug">
	.sonic-scribe--bottom-panel--words-group(:style="{ '--width': `${width}px`, '--start': `${position}px` }")
		.time(:style="{ '--time-pos': `${timePosition}px` }") {{ $Data.secondsToDisplayValue(groupTimeWithOffsets, timeOpts) }} - {{ $Data.secondsToDisplayValue(groupTimeWithOffsets + groupDuration, timeOpts) }}
		.words-line(@mousedown="onLineMouseDown")
			.word-item(v-for="word in visibleWords", :style="getWordStyle(word)", :key="word.key", @mousedown.stop="onWordMouseDown(word, 'moving')", @click="onWordSelect(word)",
				:class="{ selected: selectedWords.includes(word), 'busy': word.isProcessing }", @dblclick="onWordDblClick(word)")
				.word.flex-row.align-center
					fas(v-if="word.isProcessing", :spin="true", icon="spinner")
					span {{ word.SentenceWord }}
		.editors(v-for="selectedWord in selectedWords", v-if="selectedWords.length === 1", :style="getWordStyle(selectedWord)", :class="{ 'busy': selectedWord.isProcessing }")
			.left.item(@mousedown="onWordMouseDown(selectedWord, 'start')")
			.right.item(@mousedown="onWordMouseDown(selectedWord, 'end')")
			.highlight
		.remove-button.flex-row.align-center.center.clickable.hoverable(v-if="info.groups.length > 1", @click="removeGroup")
			fas(icon="times")
</template>

<script>
	export default {
		translationCategory: 'sonicScribe.BottomPanel',
		name: 'sonic-scribe--bottom-panel',
		components: {  },
		props: ['group', 'info'],
		data() {
			return {
				processingWordKey: null,
				processingWordMode: null,
				movingDelta: 0,
				selectedWordKey: null,
				tempOffsets: {},
				timeOpts: { preventRound: true, mFormat: 'mm:ss.S' }
			};
		},
		computed: {
			visibleWords() {
				return this.getGroupWords(this.group, this.group.words).filter(f => f.timelineStart + f.Duration >= this.info.position && (f.timelineStart < (this.info.position + this.info.audioWindow)));
			},
			width() {
				return this.groupDuration * this.info.pixelPerSecond;
			},
			position() {
				return this.info.getDisplayPosition(this.groupStartTime);
			},
			selectedWords() {
				return this.selectedWordKey ? this.visibleWords.filter(f => f.key === this.selectedWordKey || (Array.isArray(this.selectedWordKey) && this.selectedWordKey.includes(f.key))) : [];
			},
			processingWord() {
				return this.processingWordKey ? this.visibleWords.find(f => f.key === this.processingWordKey) : null;
			},
			groupStartTime() {
				return (this.group.offset + (this.tempOffsets['offset'] || 0));
			},
			groupDuration() {
				return this.group?.duration ? (this.group.duration + (this.tempOffsets['duration'] || 0)) : (this.info.buffer?.duration - this.groupStartTime);
			},
			timePosition() {
				return Math.max(0, this.position);
			},
			groupTimeWithOffsets() {
				return this.group.startOffset || 0;
			}
		},
		watch: {
			
		},
		mounted() {
			if (__DEBUG__) 
				window[`group_${this.group.id}`] = this;

			this.$eventsBus.$on('sonic-scribe-select-word', this.onSonicScribeSelectWord);
			this.$eventsBus.$on('sonic-scribe-group-offset-changing', this.onSonicScribeGroupOffsetChanging);
			this.$eventsBus.$on('sonic-scribe-group-offset-changed', this.onSonicScribeGroupOffsetChanged);
			this.$eventsBus.$on('sonic-scribe-select-words-by-range', this.onSonicScribeSelectWordsByRange);
			this.$eventsBus.$on('sonic-scribe-clear-selection', this.onSonicScribeClearSelection);
			
			document.body.addEventListener('mouseup', this.onBodyMouseUp);
			document.body.addEventListener('mousemove', this.onBodyMouseMove);
		},
		destroyed() {
			this.$eventsBus.$off('sonic-scribe-select-word', this.onSonicScribeSelectWord);
			this.$eventsBus.$off('sonic-scribe-group-offset-changing', this.onSonicScribeGroupOffsetChanging);
			this.$eventsBus.$off('sonic-scribe-group-offset-changed', this.onSonicScribeGroupOffsetChanged);
			this.$eventsBus.$off('sonic-scribe-select-words-by-range', this.onSonicScribeSelectWordsByRange);
			this.$eventsBus.$off('sonic-scribe-clear-selection', this.onSonicScribeClearSelection);

			document.body.removeEventListener('mouseup', this.onBodyMouseUp);
			document.body.removeEventListener('mousemove', this.onBodyMouseMove);
		},
		methods: {
			onLineMouseDown(e) {
				if (__DEBUG__)
					console.debug('onLineMouseDown', e);

				this.$eventsBus.$emit('sonic-scribe-clear-selection');
				this.$eventsBus.$emit('sonic-scribe-timeline', this.groupStartTime + e.offsetX / this.info.pixelPerSecond);
			},
			onSonicScribeClearSelection() {
				this.onSonicScribeSelectWord(null);
			},
			removeGroup() {
				this.$confirm(void 0, this.$tCaption('Do you want to remove range?')).then(() => {
					let groupIdx = this.info.groups.findIndex(f => f.id === this.group.id);
					if (groupIdx > -1) {
						if (this.group.duration) {
							this.info.groups.filter((f, i) => i > groupIdx).map(f => {
								f.offset -= this.group.duration;
							});
						}

						this.info.groups.splice(groupIdx, 1);
					}
				});
			},
			onSonicScribeSelectWordsByRange(start, end) {
				let arr = this.visibleWords.filter(f => end > f.timelineStart && start < (f.timelineStart + f.Duration));
				this.selectedWordKey = arr.length ? arr.map(f => f.key) : null;

				if (__DEBUG__)
					console.debug('onSonicScribeSelectWordsByRange', { start, end, arr });

				this.$eventsBus.$emit('sonic-scribe-select-by-groupkeys', this.selectedWords.map(f => f.groupKey));
			},
			onSonicScribeGroupOffsetChanging(groupId, offsets) {
				if (this.group.id !== groupId) return;

				this.tempOffsets = offsets;
			},
			onSonicScribeGroupOffsetChanged(groupId, offsets) {
				if (this.group.id !== groupId) return;

				if (Object.keys(offsets).length) {
					if (__DEBUG__)
						console.debug('onSonicScribeGroupOffsetChanged', { groupId, offsets });

					let checkParam = (key, value) => {
						if (key === 'startOffset') {
							return Math.max(0, value);
						}
						return value;
					}
					Object.keys(offsets).map(f => {
						this.$set(this.group, f, checkParam(f, (this.group[f] || 0) + offsets[f]));
					});
					this.tempOffsets = {};
				}
			},
			onSonicScribeSelectWord(word) {
				if (word?.group?.id !== this.group?.id) {
					this.selectedWordKey = null;
					return;
				}

				this.selectedWordKey = Array.isArray(word) ? word.map(f => f?.key).filter(f => f) : word?.key;
			},
			getGroupWords(group, words) {
				let deltaDuration = this.tempOffsets?.duration || 0;
				let start = (group.startOffset || 0) + (this.tempOffsets['startOffset'] || 0);
				let end = group.duration ? (start + group.duration + deltaDuration) : this.buffer?.duration;
				
				return (words || []).filter(w => !w.removed && !w.markToRemove && (w.actualStart + w.Duration) > start && (!group.duration || w.actualStart < end));
			},
			getWordStyle(word) {
				let groupStart = (this.group.startOffset || 0) + (this.tempOffsets['startOffset'] || 0);
				let startDelta = this.group.offset - groupStart;
				let actualStart = word.actualStart + startDelta;
				let start = this.getGroupDisplayPosition(actualStart);
				let end = this.getGroupDisplayPosition(actualStart + word.Duration);

				if (this.processingWord) {
					switch(this.processingWordMode) {
						case 'moving':
							if (word.actualStart >= this.processingWord.actualStart) {
								start += this.movingDelta * this.info.pixelPerSecond;
								end += this.movingDelta * this.info.pixelPerSecond;
							}
							break;
						case 'start':
							if (this.processingWord === word) {
								start = this.getGroupDisplayPosition(actualStart + this.movingDelta);
							}
							break;
						case 'end':
							if (this.processingWord === word) {
								end = this.getGroupDisplayPosition(actualStart + word.Duration + this.movingDelta);
							}
							break;
					}
				}
				
				return { 
					'--start': `${start}px`, 
					'--width': `${end - start}px`,
					'--end': `${end}px`
				}
			},
			onWordDblClick(word) {
				if (word?.isProcessing) return;
				this.$eventsBus.$emit('sonic-scribe-word-dbl-click', word);
			},
			onWordMouseDown(word, mode) {
				if (word?.isProcessing) return;
				this.processingWordMode = mode;
				this.processingWordKey = word?.key;
				this.movingDelta = 0;
			},
			onWordSelect(word) {
				this.$eventsBus.$emit('sonic-scribe-timeline', word.actualStart + this.group.offset - this.group.startOffset, true);
				this.$eventsBus.$emit('sonic-scribe-select-word', word);
			},
			getGroupDisplayPosition(v) {
				return (v - this.group.offset) * this.info.pixelPerSecond;
			},
			onBodyMouseUp() {
				let processingWord = this.processingWord;
				let process = (word, prop, value) => {
					let changesDelta = {};
					changesDelta[prop]
					if (word.hasOwnProperty('actualStart') && ['Offset', 'startOffset'].includes(prop)) {
						let delta = word[prop] - value;
						word.actualStart += prop === 'startOffset' ? delta : -delta;
						changesDelta.actualStart = prop === 'startOffset' ? delta : -delta;

						if (__DEBUG__)
							console.log('Delta fix', { delta });
					}

					changesDelta[prop] = value - (word[prop] || 0);

					this.$eventsBus.$emit('sonic-scribe-add-to-history', {
						text: this.$tCaption(`"WORD" offsets changed`).replace(/WORD/g, word.SentenceWord),
						type: 'word',
						groupId: word?.group?.id,
						wordKey: word?.key,
						changesDelta,
						confirmed: true
					});

					this.$set(word, prop, value);
				}
				if (processingWord && this.movingDelta) {
					switch(this.processingWordMode) {
						case 'moving': {
							let words = this.visibleWords.filter(f => f.actualStart > processingWord.actualStart);
							let newOffset = Math.max(0, (processingWord.startOffset || 0) - this.movingDelta);
							let deltaOffset = newOffset - (processingWord.startOffset || 0);
							if (deltaOffset) {
								process(processingWord, 'startOffset', newOffset);							
								words.map((f) => f.actualStart += this.movingDelta);
							}
							break;
						}
						case 'start': {
							let offset = processingWord.Offset + this.movingDelta;
							if (offset < 0) {
								this.movingDelta -= Math.abs(offset);
								offset = 0;
							}
							process(processingWord, 'Offset', offset);

							let duration = processingWord.Duration - this.movingDelta;
							if (duration < 0) {
								duration = 0.1;
							}
							process(processingWord, 'Duration', duration);
							break;
						}
						case 'end': {
							let duration = processingWord.Duration + this.movingDelta;
							if (duration < 0) {
								duration = 0.1;
							}
							process(processingWord, 'Duration', duration);
							break;
						}
					}
					
					this.$emit('change');
					if (__DEBUG__)
						console.debug('onBodyMouseUp', { w: processingWord, of: processingWord.startOffset, delta: this.movingDelta });
				}

				this.processingWordKey = null;
			},
			onBodyMouseMove(e) {
				if (this.processingWord) {
					this.movingDelta += e.movementX / this.info.pixelPerSecond;
				}
			},
		}
	};
</script>
<style lang='scss'>
	@import "main/themes/generated/variables.base.scss";

	.sonic-scribe--bottom-panel--words-group {
		position: absolute;
		left: var(--start);
		overflow: hidden;
		top: 0px;
		bottom: 0px;
		pointer-events: none;
		width: var(--width);

		> .words-line {
			position: absolute;
			top: calc(var(--hActions) + var(--hRuler));
			width: 100%;
			left: 0px;
			height: var(--hWords);
			bottom: 0px;
			background: #fff;
			overflow: hidden;
			border-top: 1px solid #e9e9e9;
			pointer-events: all;

			> .word-item {
				position: absolute;
				height: calc(var(--hWords) - 4px);
				left: var(--start);
				width: var(--width);
				top: 2px;
				bottom: 4px;
				overflow: hidden;
				border-left: 1px solid #ddd;
				border-right: 1px solid #ddd;
				font-size: 12px;
				font-weight: 400;
				letter-spacing: -1px;
				cursor: pointer;
				border-radius: 4px;
				pointer-events: all;

				> .word {
					position: absolute;
					height: 100%;
					overflow: hidden;
					padding-right: 3px;

					> *{
						margin-left: 3px;
						margin-right: 1px;
					}
				}

				&:hover, &.selected {
					background: $base-accent;
					color: $base-bg;
					border-radius: 4px;
					border-left: 1px solid $base-accent;
					border-right: 1px solid $base-accent;
				}
			}
		}

		.editors {
			position: absolute;
			left: 0px;
			top: 4px;
			height: 100%;
			width: 100%;
			pointer-events: none;
			z-index: 100;

			.item {
				cursor: ew-resize;
				position: absolute;
				top: calc(var(--hActions) + var(--hRuler) + var(--hWords));
				bottom: 0px;
				pointer-events: all;
				width: 10px;
				transform: translateX(-50%);
				pointer-events: all;

				&:hover {
					color: $base-accent;
				}

				&.left {
					left: var(--start);
				}

				&.right {
					left: var(--end);
				}
			}

			.highlight {
				position: absolute;
				top: calc(24px + 14px + 30px);;
				bottom: 0px;
				left: var(--start);
				width: calc(var(--end) - var(--start));
				background: #33333322;
			}
		}

		.time {
			position: absolute;
			top: calc(var(--canvasTop) + 8px);
			left: 8px;
			font-size: 9px;
			font-weight: 100;
			color: #999;
		}

		.remove-button {
			position: absolute;
			top: 4px;
			right: 4px;
			width: 22px;
			height: 22px;
			pointer-events: all;
			color: #999;
			font-size: 10px;
			top: calc(var(--canvasTop) + 4px);
			z-index: 1;
			transition: 0.2s;
			transform: scale(1);
			border-radius: 50%;

			&:hover {
				color: $base-accent;
				background: #ffffff55;
				transform: scale(1.05);
			}
		}
	}
</style>
